module.exports = __webpack_public_path__ + "hyperion-v2-static/img/esri-logo-60x60.e2e5c148.png";